import category from "./reducer";

export default category;
